import { Component, Input } from '@angular/core';

@Component({
  selector: 'progress-bar',
  styles: [
    `
      .progress-outer {
        width: 100%;
        padding: 0rem;
        background-color: #f4f4f4;
        color: #fff;
        border-radius: 0rem;
        font-size: 0.75rem;
      }
      .progress-inner {
        min-width: 1%;
        height: 0.313rem;
        white-space: nowrap;
        overflow: hidden;
        padding: 0rem;
        border-radius: 0rem;
      }
      .scale-right {
        float: right;
        font-size: 0.75rem;
        color: #9d9595;
      }
      .scale-left {
        font-size: 0.75rem;
        color: #9d9595;
      }
    `,
  ],
  template: `<div class="progress-outer">
      <div
        class="progress-inner"
        [style.width]="whichProgress(progress) + '%'"
        [style.background-color]="degraded == null ? color : whichColor(progress)"
      >
        <ng-container *ngIf="!disabledP">
          <!--{{whichProgress(progress)}}%-->
        </ng-container>
        <ng-container *ngIf="disabledP">
          {{ whichProgress(progress) }}
        </ng-container>
      </div>
    </div>
    <div><span class="scale-left">0</span> <span class="scale-right">100</span></div> `,
})
export class ProgressBarComponent {
  /** Inputs **/
  @Input() progress: string;
  @Input() color: string;
  @Input('color-degraded') degraded: any;
  @Input('disable-percentage') disabledP: boolean;

  constructor() {
    // Default color
    this.color = '#488aff';
    this.disabledP = false;
  }

  /**
   * Returns a color for a certain percent
   * @param percent The current progress
   */
  whichColor(percent: string) {
    // Get all entries index as an array
    let k: Array<any> = Object.keys(this.degraded);
    // Convert string to number
    k.forEach((e, i) => (k[i] = +e));
    // Sort them by value
    k = k.sort((a, b) => a - b);
    // Percent as number
    const p = +percent;
    // Set last by default as the first occurrence
    let last = k[0];
    // Foreach keys
    for (const val of k) {
      // if current val is < than percent
      if (val < p) {
        last = val;
      }
      // if val >= percent then the val that we could show has been reached
      else if (val >= p - 1) {
        return this.degraded[last];
      }
    }
    // if its the last one return the last
    return this.degraded[last];
  }

  whichProgress(progress: string) {
    try {
      return Math.round(+progress * 100) / 100;
    } catch {
      return progress;
    }
  }
}
